import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Col, Form, Input, Select, Tag } from 'antd';
import { observer } from 'mobx-react';
import { CURRENCY_AREAS } from '@gtintel/platform-constants';
import { useStores } from '@gtintel/platform-stores';
import { getMargin, getMarginTagColor } from '@gtintel/platform-utils';
import styles from './styles.module.scss';
function formatUSD(rawPrice) {
  const price = parsePrice(rawPrice);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(price).replace('$', '');
}
function parsePrice(rawPrice) {
  const price = parseFloat(rawPrice?.replaceAll(',', ''));
  if (Number.isNaN(price)) {
    return +rawPrice;
  }
  return price;
}
const ProposalFields = (_, childRef) => {
  const {
    control,
    getValues,
    watch
  } = useForm();
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectDetail
  } = adminProjectDetailStore;
  const getProposalFields = () => {
    return getValues();
  };
  useImperativeHandle(childRef, () => ({
    getProposalFields
  }));
  const watchCurrency = watch('currency', projectDetail.currency);
  const watchPrice = watch(['partnerPrice', 'finalPrice']);
  const projectMargin = getMargin(parsePrice(watchPrice[0]), parsePrice(watchPrice[1]));
  console.log('margin', projectMargin);
  console.log('clientPrice', watchPrice[1]);
  return <>
      <Col span={12}>
        <Form.Item className="form" label="Currency Type" initialValue={projectDetail.currency}>
          <Controller name="currency" control={control} defaultValue={projectDetail.currency} render={({
          field: {
            onChange,
            value
          }
        }) => {
          return <Select className={styles.mediumInput} options={CURRENCY_AREAS} size="large" value={value} onChange={onChange} placeholder="Select a currency" />;
        }} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item className="form" label="Partner Proposed Pricing" initialValue={projectDetail.partner_price}>
          <Controller name="partnerPrice" control={control} defaultValue={formatUSD(projectDetail.partner_price)} render={({
          field: {
            onChange,
            value
          }
        }) => {
          return <Input className={styles.mediumInput} placeholder="$10,500" value={value} onChange={event => {
            const value = event.target.value;
            if (value.replaceAll(',', '').length < 10) {
              onChange(formatUSD(value));
            }
          }} prefix={watchCurrency} />;
        }} />
        </Form.Item>
        <Tag color={getMarginTagColor(projectMargin)} key={projectMargin}>
          {(projectMargin * 100).toFixed(1)}%
        </Tag>
      </Col>
      <Col span={12}>
        <Form.Item className="form" label="Client Price" initialValue={projectDetail.final_price}>
          <Controller name="finalPrice" control={control} defaultValue={formatUSD(projectDetail.final_price)} render={({
          field: {
            onChange,
            value
          }
        }) => {
          return <Input className={styles.mediumInput} placeholder="$18,900" value={value} onChange={event => {
            const value = event.target.value;
            if (value.replaceAll(',', '').length < 10) {
              onChange(formatUSD(value));
            }
          }} prefix={watchCurrency} />;
        }} />
        </Form.Item>
      </Col>
    </>;
};
export default observer(forwardRef(ProposalFields));